import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import { Lookup, DropDownOptions } from 'devextreme-react/lookup';
import Item from "./BareRootPickListItem";
import Field from "./BareRootPickListField";
import ArrayStore from 'devextreme/data/array_store';
import * as Constants from "../../../const/constants";
import NumberBox from 'devextreme-react/number-box';
import { createStore } from 'devextreme-aspnet-data-nojquery';

let _accessToken = '';
const lookup = React.createRef();
var skipOnChangeEvent = false;

class BareRootCalculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            seedItem: '',
            seedLot: '',
            germ: 0,
            purity: 0,
            seedsLb: 0,
            orderQty: 0,
            overSow: 0,
            plsPerLb: 0,
            pkTreesLb: 0,
            required: 0
        };

        this.accessToken = props.oidc.user.access_token;
        _accessToken = props.oidc.user.access_token;

        this.onValueChangedPickLstSlctBx = this.onValueChangedPickLstSlctBx.bind(this);
        this.CalculateBareRoot = this.CalculateBareRoot.bind(this);
        this.EmailBareRoot = this.EmailBareRoot.bind(this);
        this.onClickClear = this.onClickClear.bind(this);

        this.onSeeditemValueChanged = this.onSeeditemValueChanged.bind(this);
        this.onSeedLotValueChanged = this.onSeedLotValueChanged.bind(this);
        this.onSeedGermValueChanged = this.onSeedGermValueChanged.bind(this);
        this.onSeedPurityValueChanged = this.onSeedPurityValueChanged.bind(this);
        this.onSeedsLBsValueChanged = this.onSeedsLBsValueChanged.bind(this);
        this.onSeedsOrdrQtyValueChanged = this.onSeedsOrdrQtyValueChanged.bind(this);
        this.onSeedsOverSowValueChanged = this.onSeedsOverSowValueChanged.bind(this);
        
        this.LstPick_BareRoot = createStore({
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.BareRootCalculator.GetBareRootData}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${_accessToken}`
                };
            }
        });
    }

    resetState() {
        skipOnChangeEvent = true;
        lookup.current.instance().option("value", null);
        skipOnChangeEvent = false;
        this.setState({
            seedItem: '',
            seedLot: '',
            germ: 0,
            purity: 0,
            seedsLb: 0,
            orderQty: 0,
            overSow: 0,
            plsPerLb: 0,
            pkTreesLb: 0,
            required: 0
        });
    }
    EmailBareRoot() {
        var email = Constants.CalcSeedQtyEmailToAddress;
        var subject = 'Seed Requirement';
        var emailBody = `Based on your request for ${this.state.orderQty} seedlings for item ${this.state.seedItem} with an oversow of ${this.state.overSow} we need to acquire ${this.state.required} pounds of seed. %0D%0A %0D%0A Item = ${this.state.seedItem} %0D%0A Lot = ${this.state.seedLot} %0D%0A Germ = ${this.state.germ} %0D%0A Purity = ${this.state.purity} %0D%0A Seeds perLb = ${this.state.seedsLb} %0D%0A OverSow = ${this.state.overSow} %0D%0A`;
        document.location = "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
    }
    CalculateBareRoot() {

        var txtPLS_LB = (this.state.germ / 100) * (this.state.purity / 100) * this.state.seedsLb;
        var txtPK_Trees_LB = txtPLS_LB / this.state.overSow;
        var txtRequired = Number(this.state.orderQty / txtPK_Trees_LB).toFixed(2);

        this.setState({
            plsPerLb: txtPLS_LB,
            pkTreesLb: txtPK_Trees_LB,
            required: txtRequired
        });
    }
       
    onValueChangedPickLstSlctBx(e) {
        
        if (!skipOnChangeEvent)
        {
            axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.BareRootCalculator.GetBareRootRowData}?rowid=${e.value}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: this.accessToken,
                    },
                }
            )
            .then((res) => {
                const obj = res.data;
                if (obj != null && obj != "") {
                    this.setState({
                        seedItem: obj.seeditem,
                        seedLot: obj.seedlot,
                        germ: obj.germ,
                        purity: obj.purity,
                        seedsLb: obj.seedslb
                    });
                }
            })
            .catch((err) => {
                console.log(err, "error in Getting pick list row");
            });
        }
    }
    onSeeditemValueChanged(e) {
        if (e.event) {
            this.setState({
                seedItem: e.value
            });
        }
    }
    onSeedLotValueChanged(e) {
        if (e.event) {
            this.setState({
                seedLot: e.value
            });
        }
    }
    onSeedGermValueChanged(e) {
        if (e.event) {
            this.setState({
                germ: e.value
            });
        }
    }
    onSeedPurityValueChanged(e) {
        if (e.event) {
            this.setState({
                purity: e.value
            });
        }
    }
    onSeedsLBsValueChanged(e) {
        if (e.event) {
            this.setState({
                seedsLb: e.value
            });
        }
    }
    onSeedsOrdrQtyValueChanged(e) {
        if (e.event) {
            this.setState({
                orderQty: e.value
            });
        }
    }
    onSeedsOverSowValueChanged(e) {
        if (e.event) {
            this.setState({
                overSow: e.value
            });
        }
    }
    onClickClear() {
        this.resetState();
    }

    render() {
        return (
            <div>
                        <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Calculator Bare Root
                        </h6>
                      </div>
         
                <div className="row bg-color">
                    <div className="col-md-6">
                        <Lookup
                            ref={lookup}
                            placeholder="Select Pick List"
                            dataSource={this.LstPick_BareRoot}
                            valueExpr="rowid"
                            onValueChanged={this.onValueChangedPickLstSlctBx}
                            displayExpr="bareRootPickList"
                            searchEnabled={true}
                        >
                            <DropDownOptions hideOnOutsideClick={true} />
                        </Lookup>
                    </div>
                    <div className="col-md-6 mt-2">
                        <Button
                            width={120}
                            text="Clear"
                            type="default"
                            stylingMode="contained"
                            onClick={this.onClickClear}
                        />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seed Item</span>
                        <TextBox
                            value={this.state.seedItem}
                            onValueChanged={this.onSeeditemValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Order Qty:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.orderQty}
                            onValueChanged={this.onSeedsOrdrQtyValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seed Lot:</span>
                        <TextBox
                            value={this.state.seedLot}
                            onValueChanged={this.onSeedLotValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Over Sow:</span>
                        <NumberBox
                            value={this.state.overSow}
                            onValueChanged={this.onSeedsOverSowValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Germ:</span>
                        <NumberBox
                            value={this.state.germ}
                            onValueChanged={this.onSeedGermValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>PLS per LB:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.plsPerLb}
                            readOnly={true} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Purity:</span>
                        <NumberBox value={this.state.purity}
                            onValueChanged={this.onSeedPurityValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>PK Trees LB:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.pkTreesLb}
                            readOnly={true} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seeds - LB:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.seedsLb}
                            onValueChanged={this.onSeedsLBsValueChanged} />
                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4">
                        <span>Required:</span>
                        <NumberBox
                            value={this.state.required}
                            readOnly={true}
                        />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <Button
                            text="Calculate"
                            type="default"
                            onClick={this.CalculateBareRoot}
                        ></Button>
                    </div>
                    <div className="col-md-4">
                        <Button
                            text="Email"
                            type="default"
                            onClick={this.EmailBareRoot}
                        ></Button>
                    </div>
                </div>
            </div>
        )
    }
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(BareRootCalculator);